import axios from "axios";
import { API_BASE_URL } from "../config/constants";

class WeightageModel {
    constructor() {
        const storedData = JSON.parse(localStorage.getItem("weightageData")) || {
            large: 0,
            medium: 0,
            cabin: 0,
            normal: 0,
        };

        this._large = storedData.large;
        this._medium = storedData.medium;
        this._cabin = storedData.cabin;
        this._normal = storedData.normal;

        if (this._large === 0 || this._medium === 0 || this._cabin === 0 || this._normal === 0) {
            this.initializeFromAPI();
        }
    }

    async initializeFromAPI() {
        try {
            const response = await axios.get(`${API_BASE_URL}luggage-weightage`);

            if (response.data.data && response.data.data.length > 0) {
                const weightageData = response.data.data[0];

                this._large = weightageData.CHECKIN_BAG_LARGE || 0;
                this._medium = weightageData.CHECKIN_BAG_MEDIUM || 0;
                this._cabin = weightageData.CABIN_BAG || 0;
                this._normal = weightageData.NORMAL_MAX_WEIGHTAGE || 0;

                this._saveToLocalStorage();
            } else {
                console.warn("No weightage data found in API response.");
            }
        } catch (error) {
            console.error("Error fetching weightage data:", error);
        }
    }

    get large() {
        return this._large;
    }

    get medium() {
        return this._medium;
    }

    get cabin() {
        return this._cabin;
    }

    get normal() {
        return this._normal;
    }

    _saveToLocalStorage() {
        localStorage.setItem("weightageData", JSON.stringify({
            large: this._large,
            medium: this._medium,
            cabin: this._cabin,
            normal: this._normal,
        }));
    }
}

export default new WeightageModel();